import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as fromBusinessActions from '../actions/business.actions';
import * as fromBusinessReducer from '../reducers/business.reducer';
import * as fromBusinessSelector from '../selectors/business.selector';

@Injectable()
export class BusinessFacade {

    constructor(private store: Store<fromBusinessReducer.BusinessState>) { }

    get isLoading$(): Observable<boolean> {
        return this.store.select(fromBusinessSelector.getIsLoading);
    }
    get succeeded$(): Observable<any> {
        return this.store.select(fromBusinessSelector.getSucceeded);
    }
    get hasError$(): Observable<boolean> {
        return this.store.select(fromBusinessSelector.getHasError).pipe(filter((x) => x));
    }
    get error$(): Observable<any> {
        return this.store
            .select(fromBusinessSelector.getErrorMessage);
    }
    get business$(): Observable<any[]> {
        return this.store.select(fromBusinessSelector.getBusinessData).pipe(filter((x) => !!x));
    }

    get succeededTypes$(): Observable<any> {
        return this.store.select(fromBusinessSelector.getSucceededTypes);
    }
    get eventHistoryTypes$(): Observable<any[]> {
        return this.store.select(fromBusinessSelector.getEventHistoryTypesData).pipe(filter((x) => !!x));
    }

    loadBusinessData() {
        this.store.dispatch(fromBusinessActions.loadBusinessBegin());
    }

    loadEventHistoryTypesData() {
        this.store.dispatch(fromBusinessActions.loadEventHistoryTypesBegin());
    }

    updateNFCSuccessBusinessData = () => {
        this.store.dispatch(
            fromBusinessActions.updateBusinessNFCAction()
        );
    };

    updateThemeData = (payload: any) => {
        this.store.dispatch(
            fromBusinessActions.updateThemeSuccess({payload})
        );
    };

    updateImagesSite = (payload: any) => {
        this.store.dispatch(
            fromBusinessActions.updateImagesSite({ payload })
        );
    };

}
